import { useState } from "react";
import { Headings } from "../../components";
import "./Contact.css";
import { motion } from "framer-motion";
import { gtagSendEvent } from "../../utils/gtaghelper";

const BUDGET_OPTIONS = [
  "Select your budget",
  "Under $500",
  "$500 – $1,000",
  "$1,000 – $2,500",
  "$2,500 – $5,000",
  "$5,000+",
  "Not sure yet",
];

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    number: "",
    budget: "",
    details: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    setError(false);

    try {
      const res = await fetch(
        "https://ca-email-sender.quantech.pro/api/form",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: formData.name,
            email:    formData.email,
            number:   formData.number,
            message:  formData.details,
            subject:  "Website Enquiry — Contact Form",
            source:   "Contact Section — Bottom of Page",
            plan:     "",
          }),
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.error);

      setSuccess(true);
      gtagSendEvent("contact_form_submission")

      setFormData({
        name: "",
        email: "",
        number: "",
        budget: "",
        details: "",
      });
    } catch (err) {
      console.error(err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 1 }}
      viewport={{ once: true }}
      className="section-padding"
    >
      <Headings
        title="Contact Us"
        text="Connect with Us: Let's Discuss Your Project"
      />

      <div className="contact" id="quote">
        <div className="row">
          <div className="col-md-6 col-12">
            <h2>Enter Your Details</h2>

            <form onSubmit={handleSubmit}>
              {/* Name */}
              <div className="form-group">
                <label>Name*</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  placeholder="John Doe"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Email */}
              <div className="form-group">
                <label>Email*</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  placeholder="john@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

                         <div className="form-group">
  <label htmlFor="number">Mobile Number*</label>
  <input
    id="number"
    style={{ padding: "15px" }}
    type="tel"
    className="form-control"
    name="number"
    placeholder="Mobile Number including country code (e.g., +1 555-123-4567)"
    value={formData.number}
    onChange={handleChange}
    inputMode="numeric"
    required
  />
</div>

              {/* Project Details */}
              <div className="form-group">
                <label>Project Details*</label>
                <textarea
                  className="form-control"
                  name="details"
                  rows="4"
                  placeholder="Briefly describe what you need..."
                  value={formData.details}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Feedback */}
              {success && (
                <p className="text-success mt-2">
                  ✅ Your enquiry has been sent successfully.
                </p>
              )}

              {error && (
                <p className="text-danger mt-2">
                  ❌ Something went wrong. Please try again.
                </p>
              )}

              <button
                type="submit"
                className="btn-positivus w-100"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Contact;